import { render } from "./RareDiseaseTreatmentPatternPrescribedDrugs.vue?vue&type=template&id=0c3a5a58&scoped=true"
import script from "./RareDiseaseTreatmentPatternPrescribedDrugs.vue?vue&type=script&lang=js"
export * from "./RareDiseaseTreatmentPatternPrescribedDrugs.vue?vue&type=script&lang=js"

import "./RareDiseaseTreatmentPatternPrescribedDrugs.vue?vue&type=style&index=0&id=0c3a5a58&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0c3a5a58"]])

export default __exports__